'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Generates random hash string that looks like following:
 * '722e8dace59b2ae55007cf22db507569181d15b40f47f7da8d23'
 */
var genHash = exports.genHash = function genHash() {
    var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;

    return Array(length).fill(null).map(function () {
        return Math.random().toString(16).substr(2);
    }).join('');
};

/**
 * Retruns whether var is a plain object: {}.
 * Not a function, class or any other entity with a type of "object".
 */
var isPlainObj = exports.isPlainObj = function isPlainObj(value) {
    var result = void 0;
    try {
        result = (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value != null && value.constructor.name === "Object";
    } catch (e) {
        return false;
    }
    return result;
};